// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDoJU9LWbQe16xaiQ7KfosNkSNJeqNREEE",
    authDomain: "web-ocr-47a61.firebaseapp.com",
    databaseURL: "https://web-ocr-47a61-default-rtdb.firebaseio.com/",
    projectId: "web-ocr-47a61",
    storageBucket: "web-ocr-47a61.appspot.com",
    messagingSenderId: "654491454197",
    appId: "1:654491454197:web:4aa7a86b26aa85170f53bc",
    measurementId: "G-QR13Z4HJPQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
